<template>
  <div>
     <v-data-table
        :headers="headers"
        :items="items"
      >
        <template v-slot:item.name="{ item }">
            <router-link :to="'/subcategory-tags/' + item.props.title.id + '/edit'">{{ item.props.title.name }}</router-link>
        </template>
      </v-data-table>   
  </div>
</template>
<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const SubcategoryTagRepository = RepositoryFactory.get("subcategoryTag");
export default {
    data() {
        return {
            items: [],
            headers: [
                {
                    title: "Название тэга",
                    align: "start",
                    sortable: false,
                    key: "name",
                },
            ],
        }
    },
    mounted(){
        this.list();
    },
    methods:{
        async list() {
            const result = await SubcategoryTagRepository.list();
                if (result.data.status === "success") {
                    this.items = result.data.data;
                    this.items.sort((a, b) =>  b.id - a.id);
                }
            }
        }
    }

</script>
